export function scrollToFirstError () {
  document.querySelector("[data-invalid=\"1\"]")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  })
}

export function parseError (error: any): {
  message: string
  context: Record<string, string>
} {
  const err = error?.response?.data || error

  return {
    message: err?.message || "Неизвестная ошибка",
    context: err?.extensions?.context || err?.context || {},
  }
}
